export default __webpack_public_path__ + "static/media/DeviceNoti.7e543593.svg";